import { Switch as MuiSwitch } from "@mui/material";

import { Box } from "ui/box/box";
import { getLabelSx, SwitchLabel, SwitchRoot } from "ui/switch/switch.styles";
import { type SwitchProps } from "ui/switch/switch.types";
import { useSwitch } from "ui/switch/use-switch";

export const Switch = ({
  toggleName = "",
  onChange,
  labelPlacement = "end",
  labelSx,
  ref,
  sx,
  ...rest
}: SwitchProps) => {
  const { hasLabel, accessibleName, handleChange } = useSwitch({ toggleName, onChange });

  const control = (
    <MuiSwitch
      {...rest}
      onChange={handleChange}
      slotProps={{ input: { ref, "aria-label": accessibleName } }}
    />
  );

  if (!hasLabel) {
    return <Box sx={sx}>{control}</Box>;
  }

  return (
    <SwitchRoot sx={sx}>
      <SwitchLabel
        control={control}
        label={toggleName}
        labelPlacement={labelPlacement}
        sx={getLabelSx(labelSx)}
      />
    </SwitchRoot>
  );
};
